<!-- <div>
  <iframe
    src="https://vpc-elasticsearch-dev-zwzsd24pptwzk2fttmmnnjlhaa.us-east-1.es.amazonaws.com/_dashboards/goto/5471e7519903189ccdad511cbcac8046?security_tenant=private?auth=Fe26.2**503b6ca2e3093932b84da39a70adc71019a0e83b019f95ef485cc9d627199246*tOlJPYw1guLlz_n-0-zg1g*cJ-MyRWlFB_LqJKnIfSzmev5CuCQnjTqk-8dUCd1hfMLEX6cVKvjMscCxV4lZaRn4Uw-tP4S_ZLV48Zo1tRhSZr1c4-aq6SZQZ6K3uXFGXQANDOpBdt2BqaZ-yu3CmSjiVaJczqBPzvg7IF_6eFZ_GpckMZnAawev8-O2DebtctSwwx6eD_D33mGflaSPc2fLy2H9dbuhL1HOdviRa_QQexgGbplmO5xs3Dp7HbAvRPf1FCRfIeMmuxoP7i95_1fGomhl8706rv5e4HKw5KKvQ**63137e602710acfd4c312966588b7baf1936d1d0cf5b9c79fbc074104a00df88*oEdj-zYNeWbFwrk11liryiplRa9RZ8kWMbzhQQVheeU"
    height="600"
    width="800"
  ></iframe>
</div> -->
<div>Teste</div>
<div>
  {{ url }}
</div>

<div>
  <iframe [src]="urlIframe" height="600" width="800"></iframe>
</div>
